import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { vendorLogin } from '../api/vendorApi';
// @ts-ignore
import neelsLogo from '../../assets/logos/neels_logo.png';

const VendorLogin = () => {
	const navigate = useNavigate();
	const [username, setUsername] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);

	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError('');
		if (!username || !password) {
			setError('Please enter your username and password.');
			return;
		}
		setLoading(true);
		try {
			await vendorLogin(username.trim(), password);
			navigate('/vendor-portal/dashboard', { replace: true });
		} catch (err: any) {
			setError(
				err?.apiMessage ||
					err?.response?.data?.message ||
					'Login failed. Please try again.',
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='vp vp-login-page'>
			<div className='vp-login-card'>
				<div className='vp-login-logo'>
					<img src={neelsLogo} alt='Neels' />
				</div>
				<h2>Vendor Portal</h2>
				<p className='vp-login-sub'>Sign in to view requisitions and submit quotations</p>

				{error && <div className='vp-alert vp-alert-error'>{error}</div>}

				<form onSubmit={onSubmit}>
					<div className='vp-field'>
						<label className='vp-label'>Username</label>
						<input
							className='vp-input'
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							placeholder='Enter your username'
							autoFocus
						/>
					</div>
					<div className='vp-field'>
						<label className='vp-label'>Password</label>
						<input
							className='vp-input'
							type='password'
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							placeholder='Enter your password'
						/>
					</div>
					<button
						type='submit'
						className='vp-btn vp-btn-primary vp-btn-block'
						disabled={loading}>
						{loading ? 'Signing in…' : 'Sign In'}
					</button>
				</form>

				<p className='vp-login-sub vp-mt-16 vp-mb-0' style={{ marginTop: 20 }}>
					Trouble logging in? Contact the company for your credentials.
				</p>
			</div>
		</div>
	);
};

export default VendorLogin;
